import {removePrefix} from '@wix/document-manager-utils'
import _ from 'lodash'
import type {ResolvedDataItem} from '@wix/document-services-types'
import {METADATA, type PropertyMetadata} from '../metadata'

const REF_PREFIX = '#'
export const stripHashIfExists = (query: string) => removePrefix(query, REF_PREFIX)

export interface ForEachObjectLeafCbArgs {
    val: any
    path: string
    pathArr: string[]
    metadata?: PropertyMetadata
}

type ForEachObjectLeafCb = (args: ForEachObjectLeafCbArgs) => void

export const forEachDataItemProperty = (
    dataItem: ResolvedDataItem,
    namespace: string,
    dataItemType: string,
    cb: ForEachObjectLeafCb,
    parentPath: string[] = []
): void => {
    const dataItemMetadata = METADATA[namespace]?.[dataItemType]

    _.forOwn(dataItem, (val, key) => {
        const pathArr = parentPath.concat(key)
        const path = pathArr.join('.')
        const metadata = dataItemMetadata?.[path]

        if (!metadata && _.isPlainObject(val)) {
            forEachDataItemProperty(val, namespace, dataItemType, cb, pathArr)

            if (!_.isEmpty(val)) {
                return
            }
        }

        cb({val, path, pathArr, metadata})
    })
}

export const hexToDecimal = (hex: string): number => parseInt(hex, 16)

export const decimalToHex = (num: number): string => num.toString(16).toUpperCase().padStart(2, '0')

export const removeEmptyObjects = _.partial(_.omitBy, _, _.isEmpty)
